<!-- Show state properties when not in production -->
<ng-container *ngIf="!inProduction">
  <ng-container *mobxAutorun>
    <ng-container *ngIf="relativeStorage.has()">
      <!-- Icon/button used to toggle the state properties modal -->
      <lf-icon class="value-state-icon" icon="bug" (click)="stateModal.show()">
      </lf-icon>

      <!-- Modal displayed the path's information -->
      <lf-modal #stateModal size="lg">
        <lf-modal-header>
          <code>{{ path }}</code>
        </lf-modal-header>
        <lf-modal-body>
          <h6>Value:</h6>
          <pre>{{ relativeStorage.getAsJS() | json }}</pre>
          <h6>State properties:</h6>
          <pre>{{ stateProperties | json }}</pre>
        </lf-modal-body>
        <lf-modal-footer *ngIf="hasAsyncProperties">
          <button
            lf-button
            [style]="'outline-secondary'"
            size="sm"
            (click)="relativeStorage.recomputeStateProperties('.', true)"
          >
            Recompute promises
          </button>
        </lf-modal-footer>
      </lf-modal>
    </ng-container>
  </ng-container>
</ng-container>
